import { OnInit } from '@angular/core';

export abstract class BaseModal<T> implements OnInit {

    isOn: boolean;

    initialize() {
        this.isOn = true;
    }

    closeDialog() {
        this.isOn = false;
        this.onClose();
    }

    showDialog(args: T): void {
        this.onActivate(args);
        this.initialize();
    }

    abstract onActivate(args: any): any;
    abstract onClose(): void;

    ngOnInit(): any {
        this.isOn = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/modals/modal-base.ts